import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import Dashboard from '@/components/Dashboard/Dashboard';
import TradingPairsPage from '@/pages/TradingPairs/TradingPairsPage';
import TradingPairDataCollectionPage from '@/pages/TradingPairs/TradingPairDataCollectionPage';
import StrategiesPage from '@/pages/Strategies/StrategiesPage';
import BacktestingPage from '@/pages/Backtesting/BacktestingPage';
import AutomationPage from '@/pages/Automation/AutomationPage';
import RiskDashboard from '@/pages/Risk/RiskDashboard';
import AnalyticsPage from '@/pages/Analytics/AnalyticsPage';
import AIAssistantPage from '@/pages/AI/AIAssistantPage';
import PortfolioPage from '@/pages/Portfolio/PortfolioPage';
import PaperTradingPage from '@/pages/PaperTrading/PaperTradingPage';
import SettingsPage from '@/pages/Settings/SettingsPage';

import Layout from '@/components/Layout/Layout';
import LoginPage from '@/pages/Auth/LoginPage';

const App: React.FC = () => {
  const { isAuthenticated } = useAuthStore();

  // Only bypass authentication when running on localhost in development
  const isLocalDev = import.meta.env.DEV && window.location.hostname === 'localhost';
  const shouldShowApp = isAuthenticated || isLocalDev;

  if (!shouldShowApp) {
    return <LoginPage />;
  }

  return (
    <Layout>
      <Routes>
        {/* Dashboard Route */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        
        {/* Trading Routes */}
        <Route path="/trading-pairs" element={<TradingPairsPage />} />
        <Route path="/trading-pairs/data-collection" element={<TradingPairDataCollectionPage />} />
        <Route path="/strategies" element={<StrategiesPage />} />
        
        {/* Backtesting Route */}
        <Route path="/backtesting" element={<BacktestingPage />} />
        
        {/* Automation Route */}
        <Route path="/automation" element={<AutomationPage />} />
        
        {/* Risk Management Route */}
                      <Route path="/risk" element={<RiskDashboard />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
        
        {/* AI Assistant Route */}
        <Route path="/ai-assistant" element={<AIAssistantPage />} />
        
        {/* Portfolio Route */}
        <Route path="/portfolio" element={<PortfolioPage />} />
        
        {/* Paper Trading Route */}
        <Route path="/paper-trading" element={<PaperTradingPage />} />
        
        {/* Settings Route */}
        <Route path="/settings" element={<SettingsPage />} />
        
        {/* Catch-all route */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Layout>
  );
};

export default App; 